// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__ZsmiF","col":"styles_col__1dso8"};